import { Form, Input, Select, Radio } from "antd";
import { DeleteFilled } from "@ant-design/icons";
import React from "react";

/**
 * Reusable component for additional email details form
 * Used in leadCustomerInformationForm and EmailForm
 *
 * @param {Object} item - The email item data
 * @param {Function} onDelete - Callback when delete is clicked
 * @param {number} index - Index of this email in the list
 * @param {boolean} showPrimary - Whether to show the primary radio button
 * @param {string} primaryValue - The value for the radio button (should match Radio.Group value when selected)
 * @param {boolean} isPrimary - Whether this email is currently the primary email
 */
const AdditionalEmailForm = ({
  item,
  onDelete,
  index,
  showPrimary = false,
  primaryValue,
  isPrimary = false,
}) => {
  return (
    <span className="w-full m-2 text-brand-500 items-center gap-1 bg-[#F8FAFC] p-2">
      <div className="flex-row-centered w-full justify-between">
        <span className="w-full text-sm font-[600] text-grey-700 ">
          Additional Email Details #{index + 1}
          {isPrimary && <span className="ml-2 text-xs text-blue-600 font-medium">(Primary)</span>}
        </span>
        <span
          className="bg-[#F8FAFC] p-2 w-full text-sm font-[600] text-grey-700 text-right cursor-pointer"
          onClick={onDelete}
        >
          <DeleteFilled className="text-red-500 hover:text-red-700" />
        </span>
      </div>
      <div className="flex-row-centered w-full justify-between">
        <Form.Item
          label="Email"
          name={`additional_email_${index}`}
          className={showPrimary ? "w-[94%]" : "w-full"}
        >
          <Input name={`additional_email_${index}`} className="w-[95%]" placeholder="Enter Email" />
        </Form.Item>
        {showPrimary && <Radio value={primaryValue} className="flex-shrink-0 self-start mt-9" />}
      </div>
      <div className="flex-row-centered w-full justify-between">
        <Form.Item
          label="Email Type"
          name={`additional_email_type_${index}`}
          className="bg-[#F8FAFC] w-full text-sm text-grey-700"
          rules={[{ required: true, message: "Email type is required" }]}
        >
          <Select
            placeholder="Email type"
            className="w-[90%]"
            maxTagCount="responsive"
            options={[
              { value: "PERSONAL", label: "Personal" },
              { value: "WORK", label: "Work" },
              { value: "OTHER", label: "Other" },
            ]}
          />
        </Form.Item>
        <Form.Item
          label="Email Relation"
          name={`additional_email_relation_${index}`}
          className="w-[48%] bg-[#F8FAFC] w-full pl-4 text-sm text-grey-700 "
        >
          <Select
            placeholder="Email Relation"
            className="w-[90%]"
            maxTagCount="responsive"
            options={[
              { value: "Spouse", label: "Spouse" },
              { value: "Parent", label: "Parent" },
              { value: "Child", label: "Child" },
              { value: "Sibling", label: "Sibling" },
              { value: "Friend", label: "Friend" },
              { value: "Colleague", label: "Colleague" },
              { value: "Other", label: "Other" },
            ]}
          />
        </Form.Item>
      </div>
      <div className="flex-row-centered w-full justify-between">
        <Form.Item
          className="w-[48%]"
          name={`additional_email_firstName_${index}`}
          rules={[{ required: true, message: "First name is required" }]}
          label="First Name"
        >
          <Input
            name={`additional_email_firstName_${index}`}
            className="w-[95%]"
            placeholder="Enter first name"
          />
        </Form.Item>
        <Form.Item
          className="w-[48%]"
          name={`additional_email_lastName_${index}`}
          rules={[{ required: true, message: "Last name is required" }]}
          label="Last Name"
        >
          <Input
            name={`additional_email_lastName_${index}`}
            className="w-[90%]"
            placeholder="Enter last name"
          />
        </Form.Item>
      </div>
      <div className="flex-row-centered w-full justify-between">
        <Form.Item label="Note" name={`additional_email_note_${index}`} className="w-full">
          <Input
            name={`additional_email_note_${index}`}
            className="w-[95%]"
            placeholder="Enter note"
          />
        </Form.Item>
      </div>
    </span>
  );
};

export default AdditionalEmailForm;
